import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { ManuallyTrackedAccounts } from "../Types";
export const getManuallyTrackedAccountsUrl = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/account-data-service/api/client/${clientId}/accounts/manual-tracked`
    : `https://middleware.uat.farther.com/account-data-service/api/client/${clientId}/accounts/manual-tracked`;
export default async function getManuallyTrackedAccounts(clientId, config) {
    const { data } = await axios.get(getManuallyTrackedAccountsUrl(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = ManuallyTrackedAccounts.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${getManuallyTrackedAccounts.name} Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getManuallyTrackedAccounts.js.map